export default {



  // 防抖
  debounce (fn, t) {
    let time = t || 500;
    let timer;
    return function () {
      let args = arguments;
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        timer = null
        fn.apply(this, args)
      }, time);
    }
  },
  throttle () {

  },
  getTypeTran (id) {
    switch (id) {
      case 1:
        return "海运";
      case 2:
        return "海快";
      case 3:
        return "空运";
      case 4:
        return "陆运";
      default:
        return "其他";
    }
  },

  //判断返回数据
  returnData (vue, errno, message, res, rej) {

    if (errno == 0) {

      vue.$message.success(message)
      res ? res() : ''
    } else {
      vue.$message.error(message)
      rej ? rej() : ''
    }
  },
  //判断是否具有菜单操作权限
  isOrderManagement (menu, qx) {

    for (const key in menu) {
      if (menu[key].mark == qx) {
        return true
      }
    }
  },
  transform (data) {
    let arr = []
    for (const key in data) {
      arr.push(data[key])
    }
    return arr
  },
  transformValue (data) {
    let newArr = []
    for (const key in data) {
      newArr.push({
        label: data[key],
        value: key
      })
    }
    return newArr
  },
  formatDate (nos, f) {
    let now = new Date(parseInt(nos) * 1000)
    let year = now.getFullYear();  //取得4位数的年份
    let month = now.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
    let date = now.getDate();      //返回日期月份中的天数（1到31）
    let hour = now.getHours();     //返回日期中的小时数（0到23）
    let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
    let second = now.getSeconds(); //返回日期中的秒数（0到59）

    function p (s) {
      return s < 10 ? '0' + s : s
    }
    if (f) {
      f(year, p(month), p(date), p(hour), p(minute), p(second))
      return
    }
    return `${year}-${p(month)}-${p(date)} ${p(hour)}:${p(minute)}:${p(second)}`
  },
  currencyConversion (abbreviation) {
    switch (abbreviation) {
      case CNY || RMB:
        return '人民币'
      case USD:
        return '美元'
      case VND:
        return '越南盾'
      case MOP:
        return '新加坡元'
      case JPY:
        return '日元'
      case KRW:
        return '韩元'
      case MYR:
        return '马币'
      case NTD:
        return '台币'
      case HKD:
        return '港币'
      case EUR:
        return '欧元'
      case '英镑':
        return '英镑'
      case FRF:
        return '法郎'
      case INR:
        return '印度卢比'
      case RUB:
        return '俄罗斯卢布'
      case AUD:
        return '澳大利亚元'
      case NLG:
        return '荷兰盾'
      default:
        break;
    }
  }
}